import { render, staticRenderFns } from "./aliyunOssSetting.vue?vue&type=template&id=7a110eb2&scoped=true"
import script from "./aliyunOssSetting.vue?vue&type=script&lang=ts"
export * from "./aliyunOssSetting.vue?vue&type=script&lang=ts"
import style0 from "./aliyunOssSetting.vue?vue&type=style&index=0&id=7a110eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a110eb2",
  null
  
)

export default component.exports